export default __webpack_public_path__ + "static/media/11-3.6f20e575.mp3";